module.exports = __webpack_public_path__ + "img/note-green-big-icon.472f4343.svg";